import { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import Button from "../../components/Button";
import AMDHistory from "../../components/AlMahaDrive/AMDHistory";
import AlMahaDriveMembership from "../../components/AlMahaDrive/AlMahaDriveMembership";
import Modal from "../../components/Modal";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import { Colors } from "../../config/Constants";
import {
  getDownloadMembershipReport,
  getMembershipData,
  getMembershipDetails,
  getMembershipHistoryData,
  putMembershipApprovalData,
} from "../../services/membershipService";
import {
  getFormattedMembershipList,
  getFormattedSelectFields,
} from "../../helper";
import RejectModal from "../../components/AlMahaDrive/RejectModal";
import { useLoadContext } from "../../contexts/LoadContext";
import { toast } from "react-toastify";
import { ToastMessage } from "../../components/ToastMessage";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import { SettingsIcon } from "../../components/Icons/SidebarIcons";
import { validateConfigureData } from "./ValidateAMD";
import {
  getSettings,
  getTransactionOptions,
  putEntryAccessUpdate,
} from "../../services/settingsService";
import AMDForm from "./AMDForm";
import SearchableDropdown from "../../components/SearchableDropdown";
import Textfield from "../../components/Textfield";
import { useNavigate } from "react-router-dom";
import MembershipPaymentModal from "../../components/AlMahaDrive/MembershipPaymentModal";
import SendLinkModal from "../../components/AlMahaDrive/SendLinkModal";
import { getExpiryList, membershipRegister } from "../../services/amdServices";
import Search from "../../components/Search";
import Selectfield from "../../components/Merchant/Selectfield";
import { debounce } from "underscore";
const downloadIcon = require("../../assets/images/download-icon.png");

interface MembershipItem {
  name?: string;
  lastname?: string;
  email?: string;
  phone?: string;
  countryCode?: string;
  carPlateNo?: string;
  carBrand?: string;
  carModel?: string;
  carType?: string;
  carMake?: string;
  carColor?: string;
  carPhoto?: string;
  istimaraPhoto?: string;
}

const AlMahaDrive = () => {
  const { setLoader } = useLoadContext();
  const [comment, setComment] = useState("");
  const [approveConfirmationModal, setApproveConfirmationModal] =
    useState(false);
  const [rejectConfirmationModal, setRejectConfirmationModal] = useState(false);
  const [commentError, setCommentError] = useState("");
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const [isTableDataLoading, setIsTableDataLoading] = useState(false);
  const [showFormBox, setShowFormBox] = useState(false);
  const [viewHistoryOnly, setHistoryOnly] = useState(false);
  const [membershipData, setMembership] = useState([
    {
      id: "",
      name: "",
      plate: "",
      istimara_photo: "",
      contact: "",
      car_type: "",
      car_model: "",
      car_photo: "",
      year: "",
      colour: "",
      fees: "",
    },
  ]);

  const [membershipHistoryData, setMembershipHistoryData] = useState([
    {
      name: "",
      contact: "",
      plate: "",
      car_type: "",
      car_brand: "",
      car_model: "",
      start_date: "",
      expiry_date: "",
      status: "",
    },
  ]);
  const [member, setMember] = useState({
    id: "",
    name: "",
    date: "",
    plate: "",
    contact: "",
    car_type: "",
    car_brand: "",
    car_model: "",
    year: "",
    colour: "",
    fees: "",
  });

  const [configureData, setConfigureData] = useState({
    email: "",
    phoneNumber: "",
    price: "",
    validity: "",
    percentage: "",
    renewalGracePeriod: "",
  });

  const [configureError, setConfigureError] = useState({
    email: "",
    phoneNumber: "",
    price: "",
    validity: "",
    percentage: "",
    renewalGracePeriod: "",
  });
  const [isSuccess, setIsSuccess] = useState(false);
  const [validityDropdownValues, setValidityDropdownValues] = useState([]);
  const [expiryList, setExpiryList] = useState([]);
  const [selectedExpiredItem, setExpiredItem] = useState({});
  const [searchText, setSearchText] = useState("");
  const [membershipPaymentModal, setMembershipPaymentModal] = useState(false);
  const [sendLinkModal, setSendLinkModal] = useState(false);
  const [membershipDetails, setMembershipDetails] = useState<MembershipItem>(
    {}
  );
  const [amdPage, setAmdPage] = useState(1);
  const [amdDataCount, setAmdDataCount] = useState(1);

  const [amdHistoryPage, setAmdHistoryPage] = useState(1);
  const [amdHistoryDataCount, setHistoryAmdDataCount] = useState(1);
  const [historySearchText, setHistorySearchText] = useState("");
  const [historyStatus, setHistoryStatus] = useState("");
  const navigate = useNavigate();

  const fetchValidityData = async () => {
    const validityValues = await getTransactionOptions();
    setValidityDropdownValues(
      getFormattedSelectFields(
        validityValues?.data?.data?.drive_membership_validity
      )
    );
  };

  const handleConfigureChange = (event: any) => {
    let formData = { ...configureData };
    let formError = { ...configureError };
    //@ts-ignore
    formData[event.target.name] = event.target.value;
    //@ts-ignore
    formError[event.target.name] = "";
    setConfigureData(formData);
    setConfigureError(formError);
  };

  const fetchAmdFormDetails = async () => {
    setLoader(true);
    try {
      let { data } = await getSettings("membershipfee");
      setLoader(false);
      setConfigureData({
        email: data.data.email,
        phoneNumber: data.data.phone,
        price: data.data.amount,
        validity: data.data.validity,
        percentage: data.data.percentage,
        renewalGracePeriod: data.data.renewalGracePeriod || "",
      });
    } catch (error: any) {
      setLoader(false);
      handleError(error);
    }
  };

  const postConfigureData = async (configureData: {
    name: string;
    phone: string;
    email: string;
    validity: string;
    amount: number;
    percentage: number;
    isActive: boolean;
    renewalGracePeriod: number;
  }) => {
    setLoader(true);
    try {
      const entryAccessType = "membershipfee";
      const response = await putEntryAccessUpdate(
        entryAccessType,
        configureData
      );
      setLoader(false);
      if (response.status === 200) {
        setIsSuccess(true);
      }
    } catch (error: any) {
      setLoader(false);
      handleError(error);
    }
    setShowFormBox(false);
  };

  const handleConfigureSubmit = () => {
    if (configureData.validity === "")
      setConfigureData((prevState: any) => ({
        ...prevState,
        validity: "1 year",
      }));
    if (!validateConfigureData(configureData, setConfigureError)) {
      setConfigureError({
        email: "",
        phoneNumber: "",
        price: "",
        validity: "",
        percentage: "",
        renewalGracePeriod: "",
      });
      postConfigureData({
        name: "membershipfee",
        phone: configureData.phoneNumber,
        email: configureData.email,
        validity: configureData.validity,
        amount: Number(configureData.price),
        percentage: Number(configureData.percentage),
        isActive: true,
        renewalGracePeriod: Number(configureData.renewalGracePeriod),
      });
    }
  };

  const handleRejectModalClose = () => {
    setRejectConfirmationModal(false);
    setCommentError("");
    setComment("");
  };

  const handleError = (error: any) => {
    if (navigator.onLine) {
      setOpenErrorModal(true);
      setErrorMessage({
        heading: "Something went wrong.",
        subHeading: error.message,
      });
    } else {
      toast.error(
        <ToastMessage
          message="You're offline now"
          subMessage="Oops! Internet is disconnected."
        />,
        {
          hideProgressBar: true,
        }
      );
    }
  };

  const handleApprove = (data: any) => {
    setMember(data);
    setApproveConfirmationModal(true);
  };

  const handleReject = (data: any) => {
    setMember(data);
    setRejectConfirmationModal(true);
  };

  const handleApproveCall = async () => {
    let postData = {
      approved: 1,
      rejectNotes: "",
    };
    setApproveConfirmationModal(false);
    setLoader(true);
    try {
      let { data } = await putMembershipApprovalData(postData, member.id);
      if (data.code === 201) {
        fetchMembershipList(amdPage);
        fetchMembershipHistoryList(
          amdHistoryPage,
          historySearchText,
          historyStatus
        );
        setLoader(false);
      }
    } catch (error: any) {
      setLoader(false);
      handleError(error);
    }
  };

  const handleRejectCall = async () => {
    if (comment === "") {
      setCommentError("Please enter comment.");
    } else {
      handleRejectModalClose();
      setLoader(true);
      let postData = {
        approved: 0,
        rejectNotes: comment,
      };
      try {
        let { data } = await putMembershipApprovalData(postData, member.id);
        if (data.code === 201) {
          setLoader(false);
          fetchMembershipList(amdPage);
          fetchMembershipHistoryList(
            amdHistoryPage,
            historySearchText,
            historyStatus
          );
        }
      } catch (error: any) {
        setLoader(false);
        handleError(error);
      }
    }
  };

  const handleDownload = async () => {
    setLoader(true);
    try {
      const response = await getDownloadMembershipReport(
        historyStatus,
        historySearchText,
        amdHistoryDataCount
      );
      console.log(response);
      const outputFilename = `AlMaha-drive-memberships.xlsx`;
      const url = URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
    } catch (error: any) {
      if (navigator.onLine) {
        toast.error(error.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchMembershipList(1);
    fetchExpiryList("");
    fetchMembershipHistoryList(amdHistoryPage, "", "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (showFormBox) {
      fetchValidityData();
      fetchAmdFormDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showFormBox]);

  const fetchMembershipList = async (amdPage: number) => {
    setIsTableDataLoading(true);
    try {
      let { data } = await getMembershipData(amdPage, 5);
      if (data.code === 200) {
        setAmdDataCount(data.count);
        let formattedMembership = getFormattedMembershipList(data?.data);
        setIsTableDataLoading(false);
        setMembership(formattedMembership);
      }
    } catch (error: any) {
      setIsTableDataLoading(false);
      handleError(error);
    }
  };
  const fetchExpiryList = async (searchText: string) => {
    setLoader(true);
    try {
      let { data } = await getExpiryList(searchText);
      setExpiryList(data.data);
    } catch (error: any) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };

  const fetchMembershipHistoryList = async (
    amdHistoryPage: number,
    searchQuery: string,
    status: string
  ) => {
    setIsTableDataLoading(true);
    try {
      let { data } = await getMembershipHistoryData(
        amdHistoryPage,
        searchQuery,
        status
      );
      if (data.code === 200) {
        setHistoryAmdDataCount(data.count);
        let formattedMembershipHistory = getFormattedMembershipList(data?.data);
        setIsTableDataLoading(false);
        setMembershipHistoryData(formattedMembershipHistory);
      }
    } catch (error: any) {
      setIsTableDataLoading(false);
      handleError(error);
    }
  };

  const handleCancel = () => {
    setShowFormBox(false);
  };

  const handleExpiryItemSelect = (item: any) => {
    setExpiredItem(item);
  };

  const handleSetSendLinkModal = async (data: any) => {
    console.log(data);
    setSearchText("");
    setSendLinkModal(true);
    setMembershipPaymentModal(false);
    setExpiredItem({});
    try {
      let res = await getMembershipDetails(data?.id);
      setMembershipDetails(res?.data?.data);
    } catch (error: any) {}
  };

  const handleSendLink = async (amount: any) => {
    let data = {
      name: membershipDetails?.name,
      lastname: membershipDetails?.lastname,
      email: membershipDetails?.email,
      phone: membershipDetails?.phone,
      countryCode: membershipDetails?.countryCode,
      carPlateNo: membershipDetails?.carPlateNo,
      carBrand: membershipDetails?.carBrand,
      carModel: membershipDetails?.carModel,
      carType: membershipDetails?.carType,
      carMake: membershipDetails?.carMake,
      carColor: membershipDetails?.carColor,
      carPhoto: membershipDetails?.carPhoto,
      istimaraPhoto: membershipDetails?.istimaraPhoto,
      adminRequest: true,
      price: amount,
    };
    setLoader(true);
    try {
      let res = await membershipRegister(data);
      fetchExpiryList("");
      setAmdHistoryPage(1);
      fetchMembershipHistoryList(1, historySearchText, historyStatus);
    } catch (err) {
      handleError(err);
    } finally {
      setLoader(false);
      setSendLinkModal(false);
    }
  };


  // Inside your component
  const debouncedFetchHistory = useCallback(
    debounce((value: string) => {
      setAmdHistoryPage(1);
      fetchMembershipHistoryList(1, value, historyStatus);
    }, 700),
    [historyStatus]
  );
  
  const handleSearchChange = (e: any) => {
    const value = e;
    setHistorySearchText(value);
    debouncedFetchHistory(value);
  };

  return (
    <>
      <AMDrivePageContainer>
        <AMDriveContainer>
          {!viewHistoryOnly && (
            <AMDriveSectionWrapper>
              <StyledPageHeader>
                <span>Al Maha Drive Membership</span>
                <ButtonContainer>
                  <Button
                    width="240px"
                    color={Colors.red}
                    variant="filled"
                    label="Register Member"
                    onClick={() => navigate(`/admin/register-membership`)}
                  />
                  <Button
                    width="240px"
                    color={Colors.red}
                    variant="filled"
                    label="Membership Payment "
                    onClick={() => setMembershipPaymentModal(true)}
                  />
                  <button onClick={() => setShowFormBox(!showFormBox)}>
                    <SettingsIcon fill={`${Colors.red}`} />
                    <ConfigureButton>Configure</ConfigureButton>
                  </button>
                </ButtonContainer>
              </StyledPageHeader>
              {showFormBox && (
                <FormBox>
                  <AMDForm
                    handleCancel={handleCancel}
                    handleConfigureSubmit={handleConfigureSubmit}
                    handleConfigureChange={handleConfigureChange}
                    configureData={configureData}
                    configureError={configureError}
                    validityDropdownValues={validityDropdownValues}
                  />
                </FormBox>
              )}
              <AlMahaDriveMembership
                isTableDataLoading={isTableDataLoading}
                data={membershipData}
                onApprove={handleApprove}
                onReject={handleReject}
                currentPage={amdPage}
                totalData={amdDataCount}
                onPageChange={(page: number) => {
                  setAmdPage(page);
                  fetchMembershipList(page);
                }}
              />
            </AMDriveSectionWrapper>
          )}
          <MembershipHistorySectionWrapper viewHistoryOnly={viewHistoryOnly}>
            <StyledPageHeader>
              {viewHistoryOnly ? (
                <Header>
                  <span style={{ color: "red" }}>
                    Al Maha Drive Memebership
                  </span>
                  <span>{"> Membership History"}</span>
                </Header>
              ) : (
                <div>Membership History</div>
              )}
              {viewHistoryOnly ? (
                // <ButtonWrapperDownload>
                // <div>
                <ButtonContainerBack>
                  <Button
                    width="100px"
                    variant="outlined"
                    label="Back"
                    onClick={() => setHistoryOnly(false)}
                  />
                </ButtonContainerBack>
              ) : (
                // </div>
                // </ButtonWrapperDownload>
                <ButtonWrapperDownload>
                  <FieldWrapper>
                    <Search
                      placeholder={"Search...."}
                      onChange={handleSearchChange}
                      value={historySearchText}
                    />
                  </FieldWrapper>
                  <FieldWrapper>
                    <Selectfield
                      value={historyStatus}
                      data={[
                        { label: "All", value: "" },
                        { label: "Approved", value: "approved" },
                        { label: "Rejected", value: "rejected" },
                        { label: "Active/Renewed", value: "renewed_active" },
                      ]}
                      name={""}
                      onChange={(e: any) => {
                        setHistoryStatus(e.target.value);
                        setAmdHistoryPage(1);
                        fetchMembershipHistoryList(
                          1,
                          historySearchText,
                          e.target.value
                        );
                      }}
                    />
                  </FieldWrapper>
                  <FieldWrapper>
                    <Button
                      label="Download"
                      variant="filled"
                      color={Colors.solidRed}
                      size="medium"
                      isRounded={true}
                      onClick={() => handleDownload()}
                      endIcon={downloadIcon}
                      width="10rem"
                    />
                  </FieldWrapper>
                </ButtonWrapperDownload>
              )}
            </StyledPageHeader>
            <TableWrapper>
              <AMDHistory
                onOpenSendLinkModal={handleSetSendLinkModal}
                isTableDataLoading={false}
                data={membershipHistoryData}
                currentPage={amdHistoryPage}
                totalData={amdHistoryDataCount}
                onPageChange={(page: number) => {
                  setAmdHistoryPage(page);
                  fetchMembershipHistoryList(
                    page,
                    historySearchText,
                    historyStatus
                  );
                }}
              />
            </TableWrapper>
          </MembershipHistorySectionWrapper>
        </AMDriveContainer>
      </AMDrivePageContainer>
      {approveConfirmationModal && (
        <ConfirmModal
          heading="Confirm Membership"
          subHeading={`Are you sure you want to approve ${member.name}'s Al Maha Drive membership?`}
          button1Label="Cancel"
          button2Label="Yes"
          button1Submit={() => setApproveConfirmationModal(false)}
          button2Submit={handleApproveCall}
          setOpenOrClose={() =>
            setApproveConfirmationModal(!approveConfirmationModal)
          }
        />
      )}
      {rejectConfirmationModal && (
        <Modal
          setOpenOrClose={handleRejectModalClose}
          variant={"none"}
          width="21.2rem"
        >
          <RejectModal
            setOpenOrClose={handleRejectModalClose}
            onRejectCall={handleRejectCall}
            onCommentChange={(e: any) => {
              setComment(e.target.value);
              setCommentError("");
            }}
            comment={comment}
            error={commentError}
          />
        </Modal>
      )}
      {openErrorModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setOpenErrorModal}
          onSubmit={() => setOpenErrorModal(false)}
        />
      )}
      {isSuccess && (
        <ErrorSuccessModal
          variant="success"
          heading="Saved successfully!"
          buttonLabel="Ok"
          setOpenOrClose={setIsSuccess}
          onSubmit={() => setIsSuccess(false)}
        />
      )}
      {membershipPaymentModal && (
        <MembershipPaymentModal
          handleContinue={handleSetSendLinkModal}
          setMembershipPaymentModal={() => {
            setMembershipPaymentModal(false);
            setExpiredItem({});
          }}
          onSearchChange={(e: any) => {
            fetchExpiryList(e.target.value);
            setSearchText(e.target.value);
          }}
          searchText={searchText}
          expiryList={expiryList}
          onExpiryItemSelect={handleExpiryItemSelect}
          selectedExpiredItem={selectedExpiredItem}
        />
      )}
      {sendLinkModal && membershipDetails && (
        <SendLinkModal
          setSendLinkModal={setSendLinkModal}
          membershipDetails={membershipDetails}
          onSendLink={handleSendLink}
        />
      )}
    </>
  );
};

const Header = styled.div`
  width: 50%;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const ButtonContainerBack = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-end;
  @media only screen and (max-width: 768px) {
    width: 100%;
    margin-top: 1rem;
  }
`;

const TableWrapper = styled.div``;
const AMDriveSectionWrapper = styled.div``;
const FormBox = styled.div`
  margin: 1rem 0;
  margin-top: 0.5rem;
`;
const MembershipHistorySectionWrapper = styled.div<any>`
  margin-top: ${(props) => (props.viewHistoryOnly ? "0rem" : "5rem")};
`;
const ButtonWrapperDownload = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  > div {
    width: fit-content;
    display: flex;
    gap: 1rem;
    > div > button {
      padding-right: 1rem;
      padding-left: 1rem;
    }
    > div > select {
      width: 200px;
    }
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    > div {
      width: 100%;
      > div > select {
        width: 100%;
      }
    }
  }
`;

const AMDrivePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  @media only screen and (max-width: 768px) {
    gap: 2rem;
  }
`;

const AMDriveContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  font-weight: 500;
  line-height: 1.75rem;
  padding-bottom: 1.25rem;
  color: ${Colors.black};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  > div > button {
    background: transparent;
    color: ${Colors.red};
    display: flex;
    align-items: center;
    font-size: 1.25rem;
    font-family: "Poppins-Medium";
    border: none;
  }
  @media only screen and (max-width: 768px) {
    padding: 1rem;
    padding-bottom: 0;
    font-size: 1rem;
    flex-direction: column;
  }
`;

const ConfigureButton = styled.span`
  cursor: pointer;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    magin-top: 1rem;
    flex-direction: column;
  }
`;

const FieldWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 768px) {
    width: 100%;
    > div {
      width: 100%;
      > div > select {
        width: 100%;
      }
    }
  }
`;

export default AlMahaDrive;
